import { render } from "./TheAbout.vue?vue&type=template&id=f3fce040&scoped=true"
import script from "./TheAbout.vue?vue&type=script&lang=js"
export * from "./TheAbout.vue?vue&type=script&lang=js"

import "./TheAbout.vue?vue&type=style&index=0&id=f3fce040&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fce040"]])

export default __exports__